import { jsx, css } from '@emotion/react';
import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/DurationShingleTable.jsx';

export default define`Duration Shingle Table`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/DurationShingleTable`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  view: ({ value }) => <Renderer {...value} />,
  edit: {},
});
